import { nav } from 'framer-motion/client';
import { CTABanner } from '../../components/ui/UtilsLayout';
import { imagePath } from '../../utils/imagePath';
import {
    CaseStudyCard,
  ImageWithFeatureList,
  IndustriesImagesCard,
  RetailECommerceFeatureCard,
} from '../../utils/IndustriesData/IndustriesData';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { CalendlyScheduler } from '../../components/ScheduleDemoComponents/ScheduleDemoComponents';

import { ManufacturingFeaturesData } from '../../components/data/data/Industries/IndustriesStaticData';

export const ManuFacturingIndustrial = () => {
   const [showScheduler, setShowScheduler] = useState(false);

   const openScheduler = () => setShowScheduler(true);
   const closeScheduler = () => setShowScheduler(false);
  const navigate = useNavigate();
  return (
    <div className="relative pt-14 sm:pt-20 md:pt-0">
      <div className="hidden lg:block absolute -top-[460px] right-[10px] md:right-[20px] lg:right-[0px]">
        <img
          className="w-[200px] md:w-[250px] lg:w-[430px] h-auto object-contain "
          src={imagePath?.reaearch1}
          alt="Grid AI"
        />
      </div>
      {/* Hero / Image Section */}
      <section className=" relative z-10 mt-4 sm:mt-6 md:mt-24 lg:mt-10 flex items-start lg:items-center px-3 sm:px-4 md:px-6 lg:px-8 py-8 lg:py-28">
        <div className="max-w-7xl w-full mx-auto">
          <IndustriesImagesCard
            title="Manufacturing &"
            subtitle=" Industrial"
            description="Eliminate equipment downtime, prevent accidents, and safeguard lives."
            image={imagePath?.IndustrialWeb}
            mobileImage={imagePath?.IndustrialWebMobile}
            buttonText="Schedule a Demo"
            loading="eager"
            fetchpriority="high"
            onButtonClick={openScheduler}
          />
        </div>
      </section>
      <div className=" hidden lg:block absolute sm:top-[320px] md:top-[320px] lg:top-[655px] left-0 z-[0]">
        <img
          className="w-[100px] sm:w-[180px] md:w-[460px] lg:w-[530px] h-auto object-contain"
          src={imagePath?.Research4}
          alt="Grid AI"
        />
      </div>

      <section className=" relative z-10 w-full bg-[#1E1E22] py-8 sm:py-12 md:py-16 lg:py-20 ">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-10 ">
          {/* Section Heading */}
          <div className="mb-6 sm:mb-8 md:mb-10 lg:mb-12 max-w-full sm:max-w-6xl">
            <h2 className="text-[#FFFFFF] text-2xl sm:text-xl md:text-2xl lg:text-3xl xl:text-4xl font-extrabold mb-2 sm:mb-3 md:mb-4 leading-tight">
              Our Case Studies
            </h2>
            <p className="text-[#FFFFFF] text-md sm:text-sm md:text-base lg:text-lg leading-relaxed">
              Delivering proven results across manufacturing and industrial
              environments with immersive safety training and equipment
              simulation—helping organizations reduce downtime, improve
              accuracy, and create safer, more efficient operations.
            </p>
          </div>

          {/* Cards */}
          <div className="max-w-5xl">
            <CaseStudyCard
              title="VR Mechanic Training"
              description="A VR-based car mechanic training module enabling hands-on practice of assembly, diagnostics, safety procedures, and troubleshooting within a realistic, scalable manufacturing and industrial training environment."
              image={imagePath.VrTraining}
              to="/all-industries/car-mechanic-training"
            />
          </div>
        </div>
      </section>

      {/* Image With Feature List (SEPARATE SECTION) */}
      <section className="w-full py-10 sm:py-14 md:py-16 lg:py-20 px-0 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto ">
          <ImageWithFeatureList
            titleClass="!left-[8rem] sm:!left-[8rem] md:!left-[8rem] lg:!left-[16rem] xl:!left-[18rem] !text-[18px] sm:!text-[22px] md:!text-[22px] lg:!text-[30px] xl:!text-[34px] !top-8"
            image={imagePath?.Manufacturing}
            mobileFullImage={imagePath?.ManufacturingMobile}
            imageTitle={
              <>
                Train Better.
                <br />
                Safer. Faster.
              </>
            }
            features={ManufacturingFeaturesData}
          />
        </div>
      </section>
      <div className="hidden md:block absolute bottom-[-80px] md:-left-40 lg:left-0 ">
        <img
          className="w-[180px] md:w-[260px] lg:w-[460px] h-auto object-contain rotate-180"
          src={imagePath?.research3}
          alt="Grid AI"
        />
      </div>

      <section className="w-full mx-auto px-0 sm:px-6 lg:px-8   py-12 max-w-[1350px] ">
        <div className="relative sm:left-0 md:left-4">
          <CTABanner
            welcomeText="Take the first step toward operational training excellence"
            description="Elevate your workforce with immersive, AI-powered learning."
            buttonText="Contact Us"
            navigateTo="/contact-us"
          />
        </div>
      </section>
      {showScheduler && <CalendlyScheduler onClose={closeScheduler} />}
    </div>
  );
};
